import { Injectable } from '@angular/core';
import { ApiService } from '../../core/http/api.service';
import { Observable, Subject } from 'rxjs';
import { API_URL } from '@shared/service/api.constant';
import {
  CreateFolder,
  FolderDetail,
  FolderItemList,
  FolderParams,
  FolderPermission,
  FolderPermissionPayload,
  FolderRecentSearch,
} from './folder.model';
import { DrfList } from '@shared/models/drf-response.models';

@Injectable({
  providedIn: 'root',
})
export class FolderService {
  public refreshFolderList = new Subject<void>();
  public refreshFolderList$ = this.refreshFolderList.asObservable();
  constructor(protected http: ApiService) {}

  getFolderItemList(
    param: FolderParams,
  ): Observable<DrfList<FolderItemList>> {
    return this.http.get<DrfList<FolderItemList>>(
      API_URL.folder_items,
      param,
    );
  }

  getFolderDetail(
    id: number,
    params?: any,
  ): Observable<FolderDetail> {
    return this.http.get<FolderDetail>(
      API_URL.folders + id + '/',
      params,
    );
  }

  createFolder(data: CreateFolder): Observable<FolderDetail> {
    return this.http.post<FolderDetail>(API_URL.folders, data);
  }

  updateFolder(
    id: number,
    data: Partial<CreateFolder>,
  ): Observable<FolderDetail> {
    return this.http.patch<FolderDetail>(
      API_URL.folders + id + '/',
      data,
    );
  }

  deleteFolder(id: number) {
    return this.http.delete(API_URL.folders + id + '/');
  }

  getRecentSearch(): Observable<FolderRecentSearch[]> {
    return this.http.get<FolderRecentSearch[]>(
      API_URL.folder_items + 'recent-search/',
    );
  }

  moveToFolder(
    id: number,
    data: { folder: number },
  ): Observable<any> {
    return this.http.post<any>(
      API_URL.folder_items + id + '/move/',
      data,
    );
  }

  updateLastView(id: number): Observable<any> {
    return this.http.post<any>(
      API_URL.folder_items + id + '/view/',
      null,
    );
  }

  bulkDeleteFolderItem(data: { item_ids: number[] }) {
    return this.http.post(
      API_URL.folder_items + 'bulk-destroy/',
      data,
    );
  }

  importMemos(id: number, data: { memos: number[] }) {
    return this.http.post(
      API_URL.folders + id + '/import-memos/',
      data,
    );
  }

  folderItemDownloadMultiple(data: { folder_item_ids: number[] }) {
    return this.http.post(
      API_URL.folder_items + 'download-multiple/',
      data,
    );
  }

  folderDownload(id: number) {
    return this.http.post(API_URL.folders + id + '/download/', null);
  }

  getPermissionList(
    id: number,
    param?: any,
  ): Observable<FolderPermission[]> {
    return this.http.get<FolderPermission[]>(
      API_URL.folders + id + '/permissions/',
      param,
    );
  }

  addPermission(data: FolderPermissionPayload) {
    return this.http.post<FolderPermission>(
      API_URL.folder_permission,
      data,
    );
  }

  updatePermission(
    id: number,
    data: Partial<FolderPermissionPayload>,
  ) {
    return this.http.patch<FolderPermission>(
      API_URL.folder_permission + id + '/',
      data,
    );
  }

  removePermission(id: number) {
    return this.http.delete(API_URL.folder_permission + id + '/');
  }

  importFile(folderId: number, formData: FormData) {
    return this.http.post(
      `${API_URL.folders}${folderId}/import-file/`,
      formData,
    );
  }
}
